// Constants for field categorization
export const ACADEMIC_METRIC_FIELDS = [
  'gpa',
  'sat_score',
  'act_score',
  'high_school_gpa',
  'post_secondary_gpa',
] as const;

export const ARRAY_FIELDS = [
  'academicsAlmaMaters',
  'academicEducationalExperiences',
  'resourcesClubs',
  'resourcesLanguages',
  'careerPaths',
  'careerExperiences',
  'careerEmployer',
  'demographicsAffinities',
  'demographicsRelationshipExperiences',
  'demographicsFamilyRoles',
  'demographicsChildhoodExperiences',
  'demographicsHigh5s',
  'demographicsStrengthsFinders',
  'financialExperiences',
  'financialCredentials',
  'financialProfile',
  'healthMentalHealthInterests',
  'healthInterests',
  'healthFoodNutrition',
  'healthExperiences',
  'hobbiesCreativeInterests',
  'hobbiesPassions',
  'hobbiesFavorites',
] as const;

export const JSON_PARSEABLE_FIELDS = [
  'academicApTests',
  'academicEntranceExams',
  'academicMajors',
] as const;
